import {Injectable} from '@angular/core';
import {AuthService} from "../services/auth.service";
import {HttpClient} from "@angular/common/http";

@Injectable()
export class Api {

  constructor(private authService: AuthService,
              private http: HttpClient) {
  }

  async httpGet<T>(url: string): Promise<T> {
    const token = await this.authService.getToken();
    const headers = {headers: this.authService.headers(token)};
    return this.http.get<T>(url, headers)
      .toPromise();
  }

  async httpPost<TRequest, TResponse>(url: string, requestBody: TRequest): Promise<TResponse> {
    const token = await this.authService.getToken();
    const headers = {headers: this.authService.headers(token)};
    return this.http.post<TResponse>(url, requestBody, headers)
      .toPromise();
  }

  async httpPut<TRequest, TResponse>(url: string, requestBody: TRequest): Promise<TResponse> {
    const token = await this.authService.getToken();
    const headers = {headers: this.authService.headers(token)};
    return this.http.put<TResponse>(url, requestBody, headers)
      .toPromise();
  }

  async httpPatch<TRequest, TResponse>(url: string, requestBody: TRequest): Promise<TResponse> {
    const token = await this.authService.getToken();
    const headers = {headers: this.authService.headers(token)};
    return this.http.patch<TResponse>(url, requestBody, headers)
      .toPromise();
  }

  async httpDelete(url: string): Promise<void> {
    const token = await this.authService.getToken();
    const headers = {headers: this.authService.headers(token)};
    await this.http.delete(url, headers)
      .toPromise();
  }
}
